///ts:ref=StatEvent
/// <reference path="./StatEvent.ts"/> ///ts:ref:generated
class PlatformDescribingStatEvent extends StatEvent {
	constructor(projectName:string, siteName:string, eventType:string = null) {
		super(projectName, siteName, eventType);
		let info = PlatformDescriber.getInfo();

		this.addUniq('uid', info.userId, StatDataType.noType);
		this.addUniq('src_revision', info.srcRevision, StatDataType.projDict32);
		this.addUniq('run_guid', info.runGuid, StatDataType.string);
		this.addUniq('build_date', Math.floor(info.buildDate/1000).toString(), StatDataType.string);
		//this.addUniq('location_href', info.locationHref, StatDataType.projDict8); на vk например палит кучу ненужной штуки

		this.addUniq('user_agent', info.browserInfo.userAgent, StatDataType.projDict32);

		this.addUniq('browser', info.browserInfo.browser, StatDataType.projDict32);
		this.addUniq('browser_version', info.browserInfo.version, StatDataType.projDict32);
		this.addUniq('browser_version_number', info.browserInfo.versionNumber, StatDataType.money);

		this.addUniq('parent_browser', info.browserInfo.parentBrowser, StatDataType.projDict32);
		this.addUniq('parent_browser_version', info.browserInfo.parentVersion, StatDataType.projDict32);
		this.addUniq('parent_browser_version_number', info.browserInfo.parentVersionNumber, StatDataType.money);

		this.addUniq('os_type', info.browserInfo.osType, StatDataType.projDict16);
		this.addUniq('os_name', info.browserInfo.osName, StatDataType.projDict16);
		this.addUniq('os_version', info.browserInfo.osVersion, StatDataType.projDict16);
		this.addUniq('os_version_number', info.browserInfo.osVersionNumber, StatDataType.money);
		this.addUniq('archtecture', info.browserInfo.archtecture, StatDataType.projDict16);

		this.addUniq('parsed_corretly', '' + info.browserInfo.parsedCorretly, StatDataType.projDict8);
		this.addUniq('fatal_parsing_error', '' + info.browserInfo.fatalParsingError, StatDataType.projDict8);
		this.addUniq('mobile_experimental', '' + info.browserInfo.mobileExperimental, StatDataType.projDict8);

		let glInfo = info.webGLInfo;
		this.addUniq('video_card', glInfo.videoCard, StatDataType.projDict32);
		this.addUniq('webgl_oficially_supported', '' + glInfo.officiallySupported, StatDataType.projDict8);
		this.addUniq('webgl_supported', '' + glInfo.supported, StatDataType.projDict8);
		this.addUniq('version', glInfo.version, StatDataType.projDict16);
		this.addUniq('shading_vesion', glInfo.shadingVesion, StatDataType.projDict16);
	}
}